import { SnippetDialog } from "./SnippetDialog";
import { TipDialog } from "./TipDialog";
import { DocumentDialog } from "./DocumentDialog";
import { EventDialog } from "./EventDialog";

export const DocHubDialogs = () => {
  return (
    <>
      <SnippetDialog />
      <TipDialog />
      <DocumentDialog />
      <EventDialog />
    </>
  );
};

export { SnippetDialog, TipDialog, DocumentDialog, EventDialog };
